"use client";

import { reportWebVitalMetric } from "@website/widget/scripts/web-vitals/reporter";
import { useReportWebVitalsCustom } from "./hooks";
export function WebVitals() {
  useReportWebVitalsCustom(reportWebVitalMetric);
  return null;
}